import React, { ReactNode } from "react"
import Components from "../index"
import { blokType } from "../../types"
import {
  StyledSection,
  StyledSectionBackgroundImage,
  StyledSectionContainer,
  StyledSectionHeader,
  StyledSectionIntro,
  StyledSectionLabel,
  StyledSectionHeading,
  StyledSectionDescription,
  StyledSectionBody,
} from "./partials"

export interface SectionGroupProps {
  body: blokType[]
  background_color: string
  background_image: blokType[]
  background_image_repeat_options: string
  background_image_position_options: string
}

export const SectionGroupCmp: React.FC<SectionGroupProps> = ({ 
  body,
  background_color,
  background_image,
  background_image_repeat_options,
  background_image_position_options,
}) => (
  <StyledSection data-name="section-group" is_group={true} background_image={background_image && background_image.length > 0 ? true : false} background_color={background_color}>
    {background_image && (
      <>
        {background_image.length > 0 && (
          <StyledSectionBackgroundImage
            background_image={background_image[0].media.filename}
            background_image_repeat_options={background_image_repeat_options}
            background_image_position_options={background_image_position_options}
          />
        )}
      </>
    )}
    
      {body.length > 0 && (
        <StyledSectionBody is_group={true}>
          {body.map((content: blokType) =>
            React.createElement(Components(content.component), {
              key: content._uid,
              blok: content,
            })
          )}
        </StyledSectionBody>
      )}
  </StyledSection>
)
